import { TimeService_timeServiceGetGetTime } from '@festina/unitlink-general-types/unitlink-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchUnitlinkTime =
  TimeService_timeServiceGetGetTime.useSuspenseQuery
